<template>
  <div>
    <RegistrationLayout v-if="isKcomService">
      <div class="initial-registration__text">
        <p>お申し込みありがとうございます。</p>
        <p>入力いただいたメールアドレスにログイン用のURLを送信しました。</p>
        <p class="initial-registration__text__under">ログイン後、簡単な初期設定をしていただくことで本サービスをご利用いただけます。</p>
      </div>
      <p class="c-cover-img">
        <img :src="coverImg">
      </p>
      <div class="c-links">
        <div class="c-links__item">
          <a href="/users/confirmation/new">認証メールを再送信する</a>
        </div>
      </div>
    </RegistrationLayout>
    <Page403 v-else />
  </div>
</template>

<script>
import RegistrationLayout from '../layouts/RegistrationLayout'
import CoverImg from '../../../images/common/cover_image.png'
import Page403 from '../components/Page403.vue'
import { KCOM_URLS } from '../modules/urls'

export default {
  name: 'RegistrationsApplyCompleted',
  components: {
    RegistrationLayout,
    Page403
  },
  data() {
    return {
      coverImg: CoverImg
    }
  },
  computed: {
    isKcomService() {
      return KCOM_URLS.some(url => document.domain.includes(url))
    }
  },
  async mounted() {
    // 戻るボタンを無効にする
    history.replaceState(null, '')
    window.addEventListener('popstate', () => {
      history.go(1)
    })
  }
}
</script>

<style lang="scss" scoped>
.initial-registration__text__under {
  margin-top: 40px;
}

.c-cover-img {
  max-width: 367px;
  margin: 40px auto 103px;
}
.c-links {
  justify-content: center;
}
</style>
